import { tokens as sheetTokens } from '@pkg/components/Sheet/tokens';

export const tokens = {
    summary: {
        row: {
            gap: 10,
        },
    },
    timestampBadge: {
        padding: 8,
        gap: 4,
        fontSize: 12,
    },
    title: {
        largeSize: 24,
        mediumSize: 20,
    },
    section: {
        gap: 16,
        spacing: sheetTokens.spacing.tight,
        spacingLoose: sheetTokens.spacing.loose,
        header: {
            gap: 4,
        },
    },
};
